<template>
  <modal class="transation-memo" @close-modal="close">
    <div class="row text-center">More Information: {{ memo }}</div>
    <div v-if="wdtransactionid" class="row text-center">
      Transaction ID: {{ wdtransactionid }}
    </div>
  </modal>
</template>

<script setup>
//COMPONENTS
import Modal from '@/components/global/Modal.vue';

//PROPS
const props = defineProps({
  memo: {
    type: String,
    required: true,
  },
  wdtransactionid: {
    type: String,
    required: false,
    default: '',
  },
});

//EMITS
const emit = defineEmits(['close-modal']);

//FUNCTION
function close() {
  emit('close-modal');
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/theme/variables.scss';
.transation-memo {
  color: $black-203;
}
</style>
